import Header from "../components/common/Header";
import ProfileCard from "../components/home/ProfileCard";
import SkillSet from "../components/home/SkillSet";
import ContactForm from "../components/common/Contact";
import Footer from "../components/common/Footer";
import { Helmet } from "react-helmet";
import Portfolio from "../components/home/Portfolio";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ textAlign: "center", mb: 6 }}>
    <Typography
      variant="h4"
      component="h2"
      sx={{
        fontWeight: 700,
        color: "#0F172A",
        display: "inline-block",
        position: "relative",
        pb: 1.5,
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: 36,
          height: 3,
          backgroundColor: "#3B82F6",
          borderRadius: 2,
        },
      }}
    >
      {children}
    </Typography>
  </Box>
);

function App() {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F1F5F9" }}>
      <Helmet
        title="Matsuki Takeshi | 松木健"
        link={[{ rel: "canonical", href: "https://matsuki-takeshi.com/" }]}
        meta={[
          {
            name: "description",
            content:
              "Matsuki Takeshi 松木健 - バックエンドエンジニア |メインはPHP、Laravel、Pythonでのバックエンド開発。Vue.js、React.js、Next.js等を利用したフロントエンド開発。Terraform, AWS等を利用したインフラ構築。",
          },
          {
            property: "og:description",
            content:
              "Matsuki Takeshi 松木健 - バックエンドエンジニア |メインはPHP、Laravel、Pythonでのバックエンド開発。Vue.js、React.js、Next.js等を利用したフロントエンド開発。Terraform, AWS等を利用したインフラ構築。",
          },
          { property: "og:title", content: "Matsuki Takeshi | 松木健" },
          { property: "og:type", content: "自己紹介" },
          { property: "og:url", content: "https://matsuki-takeshi.com/" },
          { property: "keywords", content: "エンジニア, フリーランス, 松木健" },
        ]}
      />
      <Header />

      {/* Profile Section */}
      <Box component="section" sx={{ backgroundColor: "#FFFFFF", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Profile</SectionTitle>
          <ProfileCard />
        </Container>
      </Box>

      {/* Skill Set Section */}
      <Box component="section" sx={{ backgroundColor: "#F8FAFC", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Skill Set</SectionTitle>
          <SkillSet />
        </Container>
      </Box>

      {/* Portfolio Section */}
      <Box component="section" sx={{ backgroundColor: "#FFFFFF", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Portfolio</SectionTitle>
          <Portfolio />
        </Container>
      </Box>

      {/* Contact Section */}
      <Box component="section" sx={{ backgroundColor: "#F8FAFC", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Contact</SectionTitle>
          <ContactForm />
        </Container>
      </Box>

      <Footer />
    </Box>
  );
}

export default App;
